import { useLatestCallback } from "@js/hooks/use-latest-callback";

import { openStartIdentityVerificationModal } from "../components/start-identity-verification-modal";

import { useUserNeedsIdentityVerification } from "./use-user-needs-identity-verification";

export const useShowPendingIdentityVerificationModal = () => {
  const { userNeedsIdentityVerification } = useUserNeedsIdentityVerification();

  const showPendingIdentityVerificationModal = useLatestCallback(() => {
    if (!userNeedsIdentityVerification) {
      return;
    }

    openStartIdentityVerificationModal();
  });

  return { showPendingIdentityVerificationModal };
};
